<div class="create-entity-attachment">
  <div class="attachments-title">
    Attachments ({{ attachmentsData.length }})
    <button rktButton btnType="link" class="attachments-btn" (click)="onAddAttachment()">
      <rkt-icon name="plus"></rkt-icon>
      Add
    </button>
  </div>

  @if (attachmentsData.length) {
    <div appDragDropAttachment (filesDropped)="onFilesDropped($event)" class="file-upload-selected-container">
      @for (file of attachmentsData; track file; let i = $index) {
        <div class="uploaded-file-item">
          <rkt-icon class="file-status" name="check"></rkt-icon>
          <div class="name">{{ file.name ?? file.file?.name }}</div>
          <button (click)="onEditFileBtnClick(i)" class="attachment-action-button attachment-action-button-edit">
            <rkt-icon name="edit"></rkt-icon>
          </button>
          <button type="button" (click)="onDeleteFileBtnClick(i)" class="attachment-action-button attachment-action-button-delete">
            <rkt-icon name="trash"></rkt-icon>
          </button>
        </div>
      }
    </div>
  } @else {
    <app-multiple-file-upload title="Drag & drop files here" [fileTypes]="allowedFileFormats" (selectedFiles)="onFileUploaded($event)">
    </app-multiple-file-upload>
  }

  <div class="files-preview"></div>
</div>
